<template>
  <div>
    <template v-if="readOnly">
      <div v-if="!modelValue?.isValid" class="verdi error-message">
        {{ modelValue?.errorMessage }}
      </div>
      <div v-else-if="modelValue?.text" class="verdi" :class="{ 'muted': modelValue?.text === '(blank)' }">
        {{ modelValue?.text }}
      </div>
      <div v-else class="verdi muted">
        (blank)
      </div>
    </template>
    <div v-else class="input-field">
      <BaseSelect :isClearable="header.isNullable" :model-value="modelValue?.value" :options="header.simpleList" @change="changed"/>
      <BaseProgressBar v-if="saving" class="progress-bar" />
      <div v-else style="height: 4px;padding: 0;margin: 0;" />
      <span v-if="hasError" style="color: var(--red-700)">Feil ved lagring!!!</span>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useTableStore } from '@/store/storeTable';
import BaseSelect from '@/components/BaseComponents/BaseSelect.vue';
import BaseProgressBar from '@/components/BaseComponents/BaseProgressBar.vue';

const props = defineProps({
  modelValue: {
    type: Object,
    default: null,
  },
  readOnly: {
    type: Boolean,
    default: false,
  },
  singleLine: {
    type: Boolean,
    default: false,
  },
  autoSave: {
    type: Boolean,
    default: true,
  },
  rowId: { type: [String, Number], default: '' },
  header: { type: Object, required: true },
});


const emit = defineEmits(['update:modelValue']);


const hasError = ref(false);
const saving = ref(false);

// TableStore
const tableStore = useTableStore();


function changed (newValue) {
  const updatedColumnData = {
    ...props.modelValue,
    value: newValue
  };

  emit('update:modelValue', updatedColumnData);

  if (!props.autoSave) return;

  const item = { rowId: props.rowId, databaseObjectId: props.header.databaseObjectId, columnName: props.header.field, oldValue: props.modelValue, newValue };
  hasError.value = false;
  saving.value = true;
  tableStore.saveData(item);
  saving.value = false;
}
</script>

<style scoped>
.verdi {
  min-height: 1.2rem;
  padding: 8px;
}

.verdi.muted {
  color: var(--gray-500);
  font-style: italic;
}

.progress-bar {
  height: 4px;
  padding: 0;
  margin: 0;
}
</style>
